/**
 *
 * Created by vsuthar on 9/21/18 File CheckboxTable
 * Project: App Portal ©PaloAlto Networks
 */
import React from 'react'
import Checkbox from '../../Checkbox/index'
import Layout from '../../Layout/index'
import SelectTable from './SelectTable'
import uuidv4 from 'uuid/v4'
import PropTypes from 'prop-types'

const nope = () => {
}
const { ContainerDimensions } = Layout

/**
 * Selectable Table
 */
class CheckboxTable extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      selection: [],
      selectAll: false,
      columns: [],
      data: []
    }
  }

  componentDidMount() {
    this.getData()
    this.preSelection()
  }

  
  /**
   *
   * @param {*} prevProps
   * We need to pass lastUpdate param to refresh data in table
   */
  componentDidUpdate(prevProps) {
    if (prevProps.lastUpdate !== this.props.lastUpdate) {
      this.getData()
    }
    else if (JSON.stringify(this.props.data) !== JSON.stringify(prevProps.data)) {
      // ^^ little expesive but we need to do this to refresh data if developer didn't pass lastUpdate from table
      this.getData()
    }
    else if (!this.props.lastUpdate) {
      console.log('You for got to Pass lastUpdate props. This is necessory to perform refresh data and boost table performance') // eslint-disable-line
    }
  }

  getData() {
    const { data } = this.props
    /**
     * create unique id for each data
     */
    const _data = data.map(item => {
      const _id = uuidv4()
      return {
        _id,
        ...item
      }
    })
    this.setState({
      data: _data
    }, this.getColumns.bind(this))
  }

  getColumns() {
    this.setState({
      columns: this.props.columns
    })
  }

  /**
   * updates selection list state
   */
  preSelection() {
    const { preSelectList } = this.props
    if (preSelectList.length) {
      this.setState({ selection: preSelectList })
    }
  }

  isSelected = key => {
    return this.state.selection.includes(key)
  }

  /**
   *
   * @param key
   * @param shift
   * @param row
   * single toggle selection
   */
  toggleSelection = (key, shift, row) => {
    let selection = [...this.state.selection]
    const keyIndex = selection.indexOf(key)
    // check to see if the key exists
    if (keyIndex >= 0) {
      // it does exist so we will remove it using destructing
      selection = [
        ...selection.slice(0, keyIndex),
        ...selection.slice(keyIndex + 1)
      ]
    }
    else {
      // it does not exist so add it
      selection.push(key)
    }
    // update the state
    this.setState({ selection }, () => {
      this.props.onSelect(selection, row)
    })
  }
  /**
   * toggle selection for select all
   */
  toggleAll = () => {
    const { perPageSelection, manual } = this.props
    const selectAll = !this.state.selectAll
    const selection = []
    if (selectAll) {
      // we need to get at the internals of ReactTable
      const wrappedInstance = this.checkboxTable.getInstance()
      //resolve state
      const resolveState = wrappedInstance.reactTable.getResolvedState()
      // the 'sortedData' property contains the currently accessible records based on the filter and sort
      let currentRecords = resolveState.sortedData
      if (perPageSelection) {
        const { page, pageSize } = resolveState
        const start = (page * pageSize) + 1
        const end = start + pageSize
        currentRecords = manual ? currentRecords = currentRecords.slice(0, pageSize) : currentRecords.slice(start, end)
        // we just push all the IDs onto the selection array
      }
      const { keyField } = this.props
      currentRecords.forEach(item => {
        selection.push(item._original[keyField])
      })
    }
    this.setState({ selectAll, selection }, () => {
      this.props.onSelect(selection)
    })
  }

  clearSelection() {
    this.setState({ selection: [] }, () => {
      this.props.onSelect(this.state.selection)
    })
  }

  render() {
    const { selectAll, columns, data } = this.state
    const { isSelected, toggleSelection, toggleAll } = this
    const props = {
      ...this.props,
      columns,
      data
    }

    /**
     *
     * @param label
     * @param rest
     * @returns {*}
     * Ant checkbox being used as default checkbox
     */
    const checkBox = ({ label, ...rest }) => {
      const { onClick, id, row } = rest
      return <Checkbox {...rest} onClick={(e) => {
        const shiftKey = e.shiftKey
        e.stopPropagation()
        onClick(id, shiftKey, row)
      }}/>
    }
    /**
     *
     * @type {{selectAll: (boolean|*), isSelected: AppTable.isSelected, toggleSelection: AppTable.toggleSelection, toggleAll: AppTable.toggleAll, SelectInputComponent: (function({label: *, [p: string]: *}): *), SelectAllInputComponent: (function({label: *, [p: string]: *}): *), selectType: string}}
     * default checkbox props. props not being passed from parents then this will use instead.
     */
    const defaultCheckBoxProps = {
      selectAll,
      isSelected,
      toggleSelection,
      toggleAll,
      SelectInputComponent: checkBox,
      SelectAllInputComponent: checkBox,
      selectType: 'checkbox'
    }
    /**
     * override default checkbox props from actual props which being passed
     */
    const checkboxProps = this.props.checkboxProps ? { ...defaultCheckBoxProps, ...this.props.checkboxProps } : defaultCheckBoxProps
    return (
      <ContainerDimensions>
        {({ width, height }) => {
          return (
            <SelectTable
              style={{ ...this.props.style, height }}
              ref={r => (this.checkboxTable = r)}
              {...props}
              checkboxProps={checkboxProps}/>
          )
        }}
      </ContainerDimensions>
    )
  }
}

/**
 *
 * @type {{onSelect: nope, preSelectList: []}}
 */
CheckboxTable.defaultProps = {
  onSelect: nope,
  preSelectList: []
}

/**
 *
 * @type {{data: shim, checkboxProps: shim, onSelect: shim}}
 */
CheckboxTable.propTypes = {
  data: PropTypes.array,
  checkboxProps: PropTypes.object,
  onSelect: PropTypes.func,
  preSelectList: PropTypes.array
}

export default CheckboxTable
